import { SponsorCards } from "../components/index";
import { NavBarFinal } from "../components/index";
import { FooterFinal } from '../components/index';

export const Sponsors = () => {
  document.title = "Florida Venture Summit | Sponsors";

  return (
    <div style={{ backgroundColor: 'black' }}>
      <NavBarFinal />
      <SponsorCards />
      <FooterFinal />
    </div>
  );
};
